import { render, staticRenderFns } from "./RoutesTreeItem.vue?vue&type=template&id=5b9a9c6c&scoped=true&"
import script from "./RoutesTreeItem.vue?vue&type=script&lang=js&"
export * from "./RoutesTreeItem.vue?vue&type=script&lang=js&"
import style0 from "./RoutesTreeItem.vue?vue&type=style&index=0&id=5b9a9c6c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9a9c6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b9a9c6c')) {
      api.createRecord('5b9a9c6c', component.options)
    } else {
      api.reload('5b9a9c6c', component.options)
    }
    module.hot.accept("./RoutesTreeItem.vue?vue&type=template&id=5b9a9c6c&scoped=true&", function () {
      api.rerender('5b9a9c6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/views/routes/RoutesTreeItem.vue"
export default component.exports